/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { LoadingOverlay } from "../../../components";
import { CloseIcon } from "../../../components/Icons";
import { PaymentCardNewForm } from "../../forms";
import { CardCreateFormType } from "../../../services/card-create/card-create.schema";
import { ISquareTokenizeResponse } from "../../../services/card-create/card-create.interface";
import { useCardCreate } from "../../../services/card-create/card-create.service";
import { useCardDetailStore } from "../../../services/card-detail/card-detail.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { MODALS } from "../../../config/params";
import { PAGES_PATH } from "../../../navigation/params";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";


const AddPaymentMethodModal = () => {
  const { closeModal } = useModal();
  const { getCreateCard, cardCreated, loading, error } = useCardCreate();
  const { setCardUpdateStatus } = useCardDetailStore();
  const { openModal, setNewlyAddedPayment } = useModal();
  const { petList }= usePetStore();
  const [isWellnessAvailable, setIsWellnessAvailable] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);


  const handleErrorClear = useCallback(() => setErrorMessage(null), []);

  const handleCloseIcon = () =>{
    closeModal();
  };

  const handleSubmit = (tokenize: ISquareTokenizeResponse, data: CardCreateFormType) => {
    setErrorMessage(null);
    userActivityLogger(MIXPANEL_EVENTS.ADD_CARD_CLICK, {});
    getCreateCard(tokenize, data);
  };

  useEffect(() => {
    let pets: IPetItemResponse[]=[];

    if (petList) {
      pets = petList.filter((data: IPetItemResponse) => {
        return (data.speciesName === "Dog" || data.speciesName === "Cat") && data.isWellnessplan;
      });
    }
    pets.length > 0 && setIsWellnessAvailable(true);
  }, [petList]);

  useEffect(() => {
    if (cardCreated) {
      userActivityLogger(MIXPANEL_EVENTS.ADD_CARD_SUCCESS, {});
      setCardUpdateStatus(true);
      if (window.location.href.includes(PAGES_PATH.MANAGE_PLAN)) {
        openModal(MODALS.UPDATE_PAYMENT_METHOD_MODAL);
      } else if (window.location.href.includes(PAGES_PATH.WELLNESS_PLAN_CONFIRM_AND_PAY)) {
        if (isWellnessAvailable) {
          setNewlyAddedPayment({ cardBrand: cardCreated.card.cardBrand, lastFourDigits: cardCreated.card.last4, cardId: cardCreated.card.id });
          openModal(MODALS.ASSIGN_PAYMENT_MODAL);
        } else {
          openModal(MODALS.UPDATE_PAYMENT_METHOD_MODAL);
        }
      } else if (window.location.href.includes(`${PAGES_PATH.USER_BILLING}/${PAGES_PATH.BILLING_METHOD}`) && isWellnessAvailable) {
        setNewlyAddedPayment({ cardBrand: cardCreated.card.cardBrand, lastFourDigits: cardCreated.card.last4, cardId: cardCreated.card.id });
        openModal(MODALS.ASSIGN_PAYMENT_MODAL);
      } else {
        closeModal();
      }
    }
    if (error) {
      const reason = error.graphQLErrors[0]?.message || "Something went wrong. Please try again.";
      userActivityLogger(MIXPANEL_EVENTS.ADD_CARD_FAILURE, { failure_reason: reason });
      setErrorMessage(reason);
    }
  }, [cardCreated, error]);


  return (
    <div className="flex flex-col justify-between h-[95%] gap-4 p-2 cursor-default">

      <div>
        <div onClick={handleCloseIcon} className="flex justify-end cursor-pointer">
          <CloseIcon width = {20} height = {20} />
        </div>
        <div className="text-xl font-semibold text-center">
          Add Payment Method
        </div>
      </div>

      <div className="flex-1 min-h-0 w-full">
        {loading ? <LoadingOverlay
          title="We are adding your payment method"
        /> : null}

        <PaymentCardNewForm
          onSubmit={handleSubmit}
          buttonText="Add Card"
          hasError={!!errorMessage}
          onErrorClear={handleErrorClear}
        />
      </div>
    </div>
  );
};

export default AddPaymentMethodModal;
